module.exports = ".faq-ul-points {\n    list-style: disc;\n    margin-left: 15px;\n}"